import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  createFilterOptions,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Category, Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { baseURL } from "../../../axios/axios";
const NotificationTemplateModal = ({ mode, handleCloseClick, editData }) => {
  const [loading, setLoading] = useState(false);
  const [notifCat, setNotifCat] = useState([]);
  const [tempFile, setTemplateFile] = useState([]);
  const [notifType, setNotificationType] = useState([]);
  const [valueDisplay, setvalueDisplay] = useState(false);
  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    const roleLink = masterAPI["notificationcategory"].link;
    await axiosPrivate
      .get(`${roleLink}`)
      .then((res) => {
        setLoading(false);
        setNotifCat(res.data.result);
      })
      .catch((e) => {
        setNotifCat([]);
        setLoading(false);
        console.log(e, "roleerror");
      });
    const templatefilelink = masterAPI["templatefile"].link;
    await axiosPrivate
      .get(`${templatefilelink}`)
      .then((res) => {
        setLoading(false);
        console.log(res);
        setTemplateFile(res.data.result);
      })
      .catch((e) => {
        setTemplateFile([]);
        console.log(e, "errorfile");
      });
    const notType = masterAPI["selectList"].notificationType;
    await axiosPrivate
      .get(`${notType}`)
      .then((res) => {
        setLoading(false);
        setNotificationType(res.data);
        console.log(res.data, "type");
      })
      .catch((e) => {
        setNotificationType([]);
        setLoading(false);
        console.log(e, "type");
      });
      if(editData.scheduleNotificationTriggerValue)
      {
        setvalueDisplay(true);
      };
  };

  const initialValue = {
    code: mode === "Edit" ? editData.code : "",
    notificationType: mode === "Edit" ? editData.notificationType : "",
    notificationCategoryId:
      mode === "Edit" ? editData.notificationCategoryId : "",
    titleForMobile: mode === "Edit" ? editData.titleForMobile : "",
    bodyForMobile: mode === "Edit" ? editData.bodyForMobile : "",
    bodyForEmail: mode === "Edit" ? editData.bodyForEmail : "",
    titleForEmail: mode === "Edit" ? editData.titleForEmail : "",
    templateFileId: mode === "Edit" ? editData.templateFileId : "",
    notificationTemplateName:
      mode === "Edit" ? editData.notificationTemplateName : "",
    scheduleNotificationTriggerValue:
      mode === "Edit" ? editData.scheduleNotificationTriggerValue : "",
  };
  console.log("editData", editData);

  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    const createLink = masterAPI["notificationtemplate"].create;
    const updateLink = masterAPI["notificationtemplate"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, value)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "createAC");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...value,
      };
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "updateAC");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? "Update Notification Template"
            : "New Notification Template"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Template Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="notificationTemplateName"
                  placeholder="Enter Notification Template Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Category
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={notifCat.length === 0}
                  options={notifCat}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.categoryName}
                  value={
                    notifCat.find(
                      (p) => p.id === values.notificationCategoryId
                    ) || null
                  }
                  freeSolo
                  onChange={(event, value, option) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("notificationCategoryId", value.id);
                      setvalueDisplay(value.categoryName === "Cycle Count Due");
                    } else {
                      setvalueDisplay(false); 
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="notificationCategoryId"
                      placeholder="Select Notification Category"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{display: valueDisplay ? "block" : "none"}}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Schedule Notification Trigger Days
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="number"
                  name="scheduleNotificationTriggerValue"
                  placeholder="Enter Trigger Days"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Type
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={notifType.length === 0}
                  options={notifType}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.text}
                  value={
                    notifType.find(
                      (p) => p.value === values.notificationType
                    ) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("notificationType", value.value);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="notificationtype"
                      placeholder="Select Notification Type"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                                                                      <CircularProgress color="inherit" size={20} />
                                                                                                    ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Body Template File
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={tempFile.length === 0}
                  options={tempFile}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.fileName}
                  value={
                    tempFile.find((p) => p.id === values.templateFileId) || null
                  }
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("templateFileId", value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span>{option.fileName}</span>
                      <OpenInNewIcon
                        style={{ cursor: "pointer", marginLeft: 8 }}
                        fontSize="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          let htmlContent = option.htmlContent;
                          const blob = new Blob([htmlContent], {
                            type: "text/html",
                          });
                          const previewUrl = URL.createObjectURL(blob);

                          window.open(previewUrl, "_blank");
                        }}
                      />
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="templateFileId"
                      placeholder="Select Body Template File"
                      //  onChange={handleChge}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                          ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Notification Subject
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="titleForEmail"
                  placeholder="Enter Title For Notification"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Body For Mobile
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="bodyForMobile"
                  placeholder="Enter Body For Mobile"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid> */}
              {/* <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Title For Email
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="titleForEmail"
                  placeholder="Enter Title For Email"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid> */}
              {/* <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Body For Email
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="bodyForEmail"
                  placeholder="Enter Body For Email"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid> */}
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default NotificationTemplateModal;
